import { ButtonPrimeReact } from "@finanedi.es/storybook"
import { GetAllEtiquetasDtoProps } from "api/Schemas/GetAllEtiquetasDto"

import { GetEtiquetaByIdDtoProps } from "api/DTOs/GetEtiquetaByIdDto"
import { useEtiquetasEmpresa } from "api/Etiqueta.hook"
import { getEtiquetaEmpresaById } from "api/Etiqueta.service"
import Spinner from "common/components/Spinner"
import { t } from "i18next"
import { useState } from "react"
import { UUIDType } from "uuid"
import CategoryCard from "./components/CategoryCard"
import { ModalConfirmDelete } from "./components/ModalConfirmDelete"
import CategoryModal from "./components/categoryModal"

export interface InfoModalProps {
  show: boolean
  isEdit: boolean
  data: GetEtiquetaByIdDtoProps | null
}
const CategoryManagement = () => {
  const {
    etiquetasEmpresa,
    etiquetasEmpresaIsLoading,
    deleteEtiquetaEmpresa,
    etiquetasEmpresaIsLoadingDelete,
  } = useEtiquetasEmpresa({ SortingCriteria: "Nombre ASC" })

  const [openDeleteModal, setOpenDeleteModal] =
    useState<GetAllEtiquetasDtoProps | null>()

  const [infoModal, setInfoModal] = useState<InfoModalProps>({
    show: false,
    isEdit: false,
    data: null,
  })

  const handleCloseModal = () => {
    setInfoModal({ show: false, isEdit: false, data: null })
  }

  const handleEditCategory = async (id: string) => {
    try {
      const category = await getEtiquetaEmpresaById(id)
      category && setInfoModal({ show: true, isEdit: true, data: category })
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    }
  }

  const handleDeleteCategory = async (id: UUIDType) => {
    await deleteEtiquetaEmpresa(id)
    setOpenDeleteModal(null)
  }
  return (
    <>
      <div className='tw-w-full tw-px-4 tw-mx-auto tw-max-w-[720px] lg:tw-max-w-[992px] xl:tw-max-w-[1320px]'>
        <div className='tw-flex tw-items-center tw-justify-between tw-mt-12'>
          <span className='tw-text-left tw-text-primary tw-font-medium tw-text-xl'>
            {t("categoryManagement.title")}
          </span>

          <ButtonPrimeReact
            className='!tw-bg-primary'
            onClick={() =>
              setInfoModal({ show: true, isEdit: false, data: null })
            }
          >
            {t("categoryManagement.addCategory")}
          </ButtonPrimeReact>
        </div>
        {etiquetasEmpresaIsLoading ? (
          <div className='tw-flex tw-justify-center tw-items-center tw-w-full !tw-h-fit tw-pt-2'>
            <Spinner className='tw-text-secondary' />
          </div>
        ) : (
          <div className='tw-pt-8 tw-grid tw-grid-rows-auto tw-grid-col-1 lg:tw-grid-cols-2 xl:tw-grid-cols-4 tw-gap-3 tw-place-items-center'>
            {etiquetasEmpresa?.items?.map(
              (category: GetAllEtiquetasDtoProps) => (
                <button
                  className='tw-w-full'
                  type='button'
                  key={category.id}
                  // @ts-expect-error TS(2345): Argument of type 'string | undefined' is not assig...
                  onClick={() => handleEditCategory(category.id)}
                >
                  <CategoryCard
                    category={category}
                    handleDeleteCategory={() => setOpenDeleteModal(category)}
                  />
                </button>
              )
            )}
          </div>
        )}
      </div>
      {infoModal.show && (
        <CategoryModal
          visible={infoModal.show}
          handleCloseModal={handleCloseModal}
          infoModal={infoModal}
        />
      )}
      <ModalConfirmDelete
        isOpen={!!openDeleteModal?.id}
        onConfirm={() => {
          // @ts-expect-error TS(2345): Argument of type 'string' is not assignable to par...
          openDeleteModal?.id && handleDeleteCategory(openDeleteModal.id)
        }}
        onCancel={() => setOpenDeleteModal(null)}
        isLoading={etiquetasEmpresaIsLoadingDelete}
      />
    </>
  )
}

export default CategoryManagement
